import { useQuery } from "@tanstack/react-query";
import { doormanThreadQuery, planQuery } from "../../lib/queries";

/**
 * Does this session's tier buy AI work at all?
 *
 * ONE DEFINITION, because four surfaces now branch on it — the usage ring, the
 * doorman's composer, the desk's "personalize your house rules" and the share
 * sheet's "ask Nob to write you one" — and four hand-rolled copies of the same
 * question are how they come to disagree about who is on Free. It is `metered`
 * and never `tier === "free"`: a trial runs on a real tier with a real limit
 * (§5.1) and must behave as a plan does, and the server is the one that knows.
 *
 * `null` means NOBODY HAS SAID YET, and it is a third answer rather than a
 * pessimistic guess. A surface that treats an unanswered read as Free flashes
 * an upsell at a paying subscriber on every cold load; one that treats it as a
 * plan opens a composer that the next frame takes away. Callers wait.
 *
 * The plan lane is the authority and the doorman thread is the fallback — the
 * thread carries the same meter, and it is the one read that still answers when
 * plans are dark behind their flag, where every tier is Free and unmetered.
 */
export function useMetered(): boolean | null {
  const plan = useQuery(planQuery());
  const thread = useQuery(doormanThreadQuery());
  if (plan.data) return plan.data.plan.metered;
  if (thread.data?.ok) return thread.data.thread.plan.metered;
  return null;
}
